<div class="flex justify-center">
  <button
    class="btn rounded-full bg-gray-950 w-20 h-20"
    (click)="onButtonClick()"
  >
    <div>
      @if (menuState()) {
        <fa-icon
          class="text-white"
          [icon]="faXmark"
          size="xl"
        />
      } @else {
        <fa-icon
          class="text-white"
          [icon]="faBars"
          size="xl"
        />
      }
    </div>
  </button>
</div>
